import { render, staticRenderFns } from "./vacancy-card.vue?vue&type=template&id=cc923aa8&scoped=true&lang=pug"
import script from "./vacancy-card.vue?vue&type=script&lang=ts"
export * from "./vacancy-card.vue?vue&type=script&lang=ts"
import style0 from "./vacancy-card.vue?vue&type=style&index=0&id=cc923aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc923aa8",
  null
  
)

export default component.exports